.threadbox {
    max-width: var(--app-thread-width);
    margin: 0 auto;
    padding-top: var(--mantine-spacing-md);
    padding-bottom: var(--mantine-spacing-md);
}

.viewport {
    --thread-top-offset: 53px;
}

@keyframes panelEnter {
    from {
        opacity: 0;
        transform: translate3d(0, 6px, 0);
    }
    to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
}

.panel {
    display: none;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.panel[data-active="true"] {
    display: flex;
    animation: panelEnter 180ms ease-out both;
    will-change: opacity, transform;
}

@media (prefers-reduced-motion: reduce) {
    .panel[data-active="true"] {
        animation: none;
    }
}
